import type { IFooterBlockProps } from "./FooterBlock.props";
import { FooterStandard } from "../../../../modules/footer/components/FooterStandard/FooterStandard";

export const FooterBlock = (props: IFooterBlockProps) => {
  const hasContent = Boolean(
    props.logo ||
    props.description ||
    props.contact?.email ||
    props.contact?.phone ||
    props.contact?.address ||
    props.navigationGroups?.length ||
    props.socialLinks?.length ||
    props.secondaryLinks?.length ||
    props.copyright,
  );

  if (!hasContent) {
    return null;
  }

  return <FooterStandard {...props} />;
};

FooterBlock.displayName = "Block::FooterBlock";
